// THIS FILE WAS BROUGHT TO YOU BY HAND WITH LOVE AND TEARS
import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const ChevronUp = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fill={color}
            d="M7.99455812,12.4606243 C5.79755185,10.387468 4,8.68179901 4,8.67025011 C4,8.65870122 4.38866534,8.28292732 4.86369921,7.83519683 L5.72739666,7.02114245 L8.85277011,9.97030854 L11.9781423,12.9194763 L15.1147174,9.95973814 L18.2512922,7 L19.125646,7.82488055 C19.6065408,8.27856452 20,8.65907578 20,8.67046297 C20,8.69075068 12.0215156,16.2299995 12.000045,16.2299995 C11.9940339,16.2299995 10.1915644,14.5337805 7.99455812,12.4606243 Z"
            transform="translate(12.000000, 11.615000) rotate(180.000000) translate(-12.000000, -11.615000) "
        ></path>
    </StarryUIIcon>
);
